import { render, staticRenderFns } from "./DepartmentsTree.vue?vue&type=template&id=26750f80&scoped=true"
import script from "./DepartmentsTree.vue?vue&type=script&lang=ts"
export * from "./DepartmentsTree.vue?vue&type=script&lang=ts"
import style0 from "./DepartmentsTree.vue?vue&type=style&index=0&id=26750f80&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26750f80",
  null
  
)

export default component.exports